export default __webpack_public_path__ + "static/media/contentBoxBg.7fbffa36.png";